import { useEffect, useState } from 'react'
import { OAuth } from './oauth'
import getCollection from '../resources/support/getCollection'
import { useIdentity } from '../hooks/useIdentity'
import { useTracking } from '../support/useTracking'
import { mixpanel } from '../support/mixpanel'
import { logger } from '../utils/logging'

export function useAccountInitializer(token: string | undefined): { isInitialized: boolean; error: string | null } {
  const { identity, setIdentity, isInitialized } = useIdentity()
  const tracker = useTracking()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!token) {
      return
    }

    if (token !== identity?.token) {
      setError(null)
      OAuth.fetchProfile()
        .then((data) => {
          if (data?.environments) {
            getCollection('ENVIRONMENTS').hydrateWithFreshData(data.environments)
            getCollection('APPS').hydrateWithFreshData(data.apps)

            setIdentity({ ...data, token })

            // Don't block on mixpanel errors
            try {
              mixpanel.identify(data.user.id)
              mixpanel.people.set({
                $email: data.user.email,
                $name: data.user.name,
                accountId: data.account.id,
              })
            } catch (error) {
              logger.error('[useAccountInitializer] Error setting mixpanel user:', error)
            }

            tracker.identify(data)
            tracker.capture('new dashboard - login')
          }
        })
        .catch((err) => {
          logger.error('[useAccountInitializer] Authentication error:', err)
          setError('Authentication failed')
        })
    }
  }, [token])

  return { isInitialized, error }
}
